import { ChevronRight, Server } from 'lucide-react';

/**
 * "Advanced — self-hosted HIVE server": a collapsed address field for people who
 * run their own HIVE server. Empty = Collect's own server, reached on this site
 * (lib/settings.ts SAME_ORIGIN); the infrastructure address is never shown or needed.
 * Shared by the sign-in form and Settings; the parent owns the value and checks it
 * (serverUrlFromInput) before saving.
 */
export function AdvancedServer({
  id,
  value,
  onChange,
  open,
  onOpenChange,
  className = '',
}: {
  id: string;
  value: string;
  onChange: (v: string) => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  className?: string;
}) {
  return (
    <details
      className={className}
      open={open}
      onToggle={(e) => onOpenChange((e.currentTarget as HTMLDetailsElement).open)}
    >
      <summary
        className="label cursor-pointer select-none flex items-center gap-2 opacity-80 hover:opacity-100"
        style={{ listStyle: 'none' }}
      >
        <ChevronRight size={12} style={{ transition: 'transform 150ms', transform: open ? 'rotate(90deg)' : 'none' }} />
        <Server size={12} />
        Advanced — self-hosted HIVE server
      </summary>
      <label className="sr-only" htmlFor={id}>Server address</label>
      <input
        id={id}
        className="field mt-3"
        type="url"
        inputMode="url"
        placeholder="https://your-hive.example"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        spellCheck={false}
        autoComplete="off"
      />
      <p className="text-xs mt-2" style={{ color: 'rgba(240,253,244,0.55)' }}>
        Only if you run your own HIVE server. Leave it empty to use Qodoonect.
      </p>
    </details>
  );
}
